import React, { useContext, useEffect, useState, forwardRef } from 'react';
import { Modal, Button, Form, Col, Row, FloatingLabel } from 'react-bootstrap';
import Select, { createFilter } from 'react-select';
import AsyncSelect from 'react-select/async';
import CustomOption from '../../utils/Elements/CustomOption';
import { ParentContext, CompanyContext, EmployeeContext } from '../../layouts/Dashboard/LayoutDashboard';
import { jwtDecode } from 'jwt-decode';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//see this for date formats: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
//see this for date picker: https://reactdatepicker.com/

import '../Pages.css';

export const ActivitySearch = ({ showModal, closeModal, activityFilters, setActivityFilters }) => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const activityTypesEndpoint = `${api}/v1/activity/types`;
  const salesRepsEndpoint = `${api}/v1/individuals/salesreps`;
  const pricingPlansEndpoint = `${api}/v1/customers/pricingplans`;
  //const activityRecurrenceEndpoint = `${api}/v1/activity/recurrences`;
  //const contactsEndpoint = `${api}/v1/individuals/list`;

  const parentsSearch = `${api}/v1/parents/search`;
  const companySearch = `${api}/v1/companies/search`;
  const individualsSearch = `${api}/v1/individuals/search`;


  const { selectedParentID, allParents } = useContext(ParentContext);
  const { selectedCompanyID, selectedCompanyParentID, allCompanies } = useContext(CompanyContext);
  const { allEmployees } = useContext(EmployeeContext);
  

  //const [identity, setIdentity] = useState({});

  const [filterTotal, setFilterTotal] = useState(0);
  //const [applyFilter, setApplyFilter] = useState(false);
  const [filterMessage, setFilterMessage] = useState("");

  //const [parents, setParents] = useState([
  //  { value: 0, label: "All" },
  //]);
  //const [parent, setParent] = useState(parents[0]);
  const [parent, setParent] = useState(null);

  //const [companies, setCompanies] = useState([
  //  { value: 0, label: "All" },
  //]);
  //const [company, setCompany] = useState(companies[0]);
  const [company, setCompany] = useState(null);

  //const defaulContact = { label: "Any", value: 0 };
  //const [contacts, setContacts] = useState([defaulContact]);
  const [contact, setContact] = useState(null);
  //const [contactsLoading, setContactsLoading] = useState(false);

  
  //const defaultEmployee = { label: "Any", value: 0 };
  //const [employees, setEmployees] = useState([]);
  const [activityFor, setActivityFor] = useState(null);
  //const [employeesLoading, setEmployeesLoading] = useState(false);


  //const defaultSalesRep = { label: "Any", value: 0 };
  const [salesReps, setSalesReps] = useState([]);
  const [salesRep, setSalesRep] = useState(null);
  const [salesRepsLoading, setSalesRepsLoading] = useState(false);

  const [pricingPlans, setPricingPlans] = useState([]);
  const [pricingPlan, setPricingPlan] = useState(null);
  const [pricingPlansLoading, setPricingPlansLoading] = useState(false);

  //the remaining filters are static
  const defaulActivityType = { label: "All", value: 0 };
  const [activityTypes, setActivityTypes] = useState([defaulActivityType]);
  const [activityType, setActivityType] = useState(defaulActivityType);
  const [activityTypesLoading, setActivityTypesLoading] = useState(false);

  const [dateTypes] = useState([
    { value: 0, label: "Activity Date" },
    { value: 1, label: "Date Completed" },
    { value: 2, label: "Date Created" },
  ]);
  const [dateType, setDateType] = useState(dateTypes[0]);

  const [recurrences] = useState([
    { value: -1, label: 'All' },
    { value: 0, label: 'Once' },
    { value: 1, label: 'Daily' },
    { value: 2, label: 'Weekly' },
    { value: 3, label: 'Monthly' },
    { value: 4, label: 'Annually' },
  ]);
  const [recurrence, setRecurrence] = useState(recurrences[0]);

  const [statuses] = useState([
    { value: 0, label: "To Do" },
    { value: 4, label: "To Do & Done" },
    { value: 1, label: "Done" },
    { value: 2, label: "Canceled" },
    { value: 3, label: "All" },
  ]);
  const [status, setStatus] = useState(statuses[0]);

  const [dateRanges] = useState([
    //{ value: 0, label: "Upcoming" },
    { value: 0, label: (<><span title={"All Dates prior to 7 days from now."}>Upcoming</span></>) },
    { value: 1, label: "Today" },
    { value: 2, label: "Next 7 Days" },
    { value: 3, label: "Next 30 Days" },
    { value: 4, label: "Last 7 Days" },
    { value: 5, label: "Last 30 Days" },
    { value: 6, label: "Custom" },
    { value: 7, label: "All" },
  ]);
  const defaultDateRange = 0;
  const customDateRange = 6;
  const allDateRange = 7;
  const [dateRange, setDateRange] = useState(dateRanges[defaultDateRange]);


  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [customDatesDisabled, setCustomDatesDisabled] = useState(true);
  
  const getStoredToken = () => {
    return localStorage.getItem('token');
  };
  const storedToken = getStoredToken();

  //set filters exit modal
  const viewFilters = () => {
    activityFilters.parentId = parent ? parent.value : 0;
    activityFilters.companyId = company ? company.value : 0;
    activityFilters.activityFor = activityFor ? activityFor.value : 0;
    activityFilters.contactId = contact ? contact.value : 0;
    activityFilters.contactName = contact ? contact.label : "";
    activityFilters.salesRepId = salesRep ? salesRep.value : 0;
    activityFilters.activityType = activityType.value;
    activityFilters.dateType = dateType.value;

    activityFilters.recurrence = recurrence.value;
    activityFilters.pricingPlanId = pricingPlan ? pricingPlan.value : 0;
    activityFilters.status = status.value;

    activityFilters.dateRange = dateRange.value;
    activityFilters.dateRangeStart = fromDate;
    activityFilters.dateRangeEnd = toDate;
    activityFilters.filterTotal = filterTotal;
    activityFilters.applyFilter = true;
    setActivityFilters(activityFilters);
    closeModal();
  };

  //reset filters
  const resetFilters = () => {

    if ((selectedCompanyParentID ? selectedCompanyParentID : selectedParentID) === 0) {
      setParent(null);
    } else {
      setParent(allParents.find(x => x.value === (selectedCompanyParentID ? selectedCompanyParentID : selectedParentID)));
    }

    if (selectedCompanyID === 0) {
      setCompany(null);
    } else {
      setCompany(allCompanies.find(x => x.value === selectedCompanyID));
    }
    
    //setParent(parents.find(x => x.value === (selectedCompanyParentID ? selectedCompanyParentID : selectedParentID)));
    //setCompany(companies.find(x => x.value === selectedCompanyID));

    setContact(null);
    setSalesRep(null);
    setPricingPlan(null);

    const identity = jwtDecode(storedToken);

    setActivityFor(allEmployees.find(x => x.data === identity.sub.toUpperCase()));

    setActivityType(activityTypes[0]);
    setDateType(dateTypes[0]);
    setRecurrence(recurrences[0]);
    setStatus(statuses[0]);
    setDateRange(dateRanges[defaultDateRange]);
    //setApplyFilter(false);
  };

  
  const handleParentChange = (value) => {
    setParent(value);
    setCompany(null);
    setContact(null);
  };
  const handleCompanyChange = (value) => {
    setCompany(value);
    setContact(null);
  };
  const handleContactChange = (value) => {
    setContact(value);
  };
  const handleSalesRepChange = (value) => {
    setSalesRep(value);
  };
  const handlePricingPlanChange = (value) => {
    setPricingPlan(value);
  };
  const handleActivityForChange = (value) => {
    setActivityFor(value);
  };
  const handleActivityTypeChange = (value) => {
    setActivityType(value);
  };
  const handleRecurrenceChange = (value) => {
    setRecurrence(value);
  };
  const handleStatusChange = (value) => {
    setStatus(value);
  };
  const handleDateTypeChange = (value) => {
        setDateType(value);
      };
  const handleDateRangeChange = (value) => {
    setDateRange(value);
  };
  const handleFromDateChange = (value) => {
    setFromDate(value);
  };
  const handleToDateChange = (value) => {
    setToDate(value);
  };
  
  
  //const fetchAccount = async () => {
  //  try {
  //    const identity = jwtDecode(storedToken);
  //    setIdentity(identity);
  //  } catch (error) {
  //    console.error('Error:', error);
  //  }
  //};


  //const fetchParents = () => {
  //  //let p = allParents;
  //  //clone array
  //  let p = allParents.map(a => ({ ...a }));
  //  p.unshift({ value: 0, label: "All" });
  //  setParents(p);
  //};

  //const fetchCompanies = () => {
  //  //let c = allCompanies;
  //  //clone array
  //  let c = allCompanies.map(a => ({ ...a }));
  //  c.unshift({ value: 0, label: "All" });
  //  setCompanies(c);
  //};


  //const fetchContacts = async () => {

  //  if (storedToken) {

  //    try {
  //      setContactsLoading(true);

  //      const pid = parent ? parent.value : 0;
  //      const cid = company ? company.value : 0;

  //      const response = await fetch(contactsEndpoint + `?parentId=${pid}&companyId=${cid}`, {
  //        method: 'GET',
  //        headers: {
  //          Authorization: `Bearer ${storedToken}`,
  //          'Content-Type': 'application/json',
  //        }
  //      });
  //      if (response.ok) {
  //        const data = await response.json();
  //        data.unshift(defaulContact);
  //        setContacts(data);
  //        setContactsLoading(false);

  //      } else {
  //        setContacts([defaulContact]);
  //        setContactsLoading(false);
  //        console.error('Activity Search: Failed to fetch contacts');
  //      }

  //    } catch (error) {
  //      setContacts([defaulContact]);
  //      setContactsLoading(false);
  //      console.error('Activity Search: Failed to fetch contacts');
  //    }

  //  }

  //};

  const fetchSalesReps = async () => {
    if (storedToken) {

      try {
        setSalesRepsLoading(true);

        const pid = parent ? parent.value : 0;
        const cid = company ? company.value : 0;

        const response = await fetch(salesRepsEndpoint + `?parentId=${pid}&companyId=${cid}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          //data.unshift(defaultSalesRep);
          setSalesReps(data);
          setSalesRepsLoading(false);

        } else {
          setSalesReps([]);
          setSalesRepsLoading(false);
          console.error('Activity Search: Failed to fetch sales reps');
        }

      } catch (error) {
        setSalesReps([]);
        setSalesRepsLoading(false);
        console.error('Activity Search: Failed to fetch sales reps');
      }
    }
  };

  const fetchPricingPlans = async () => {
    if (storedToken) {
      try {
        setPricingPlansLoading(true);
        const response = await fetch(pricingPlansEndpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setPricingPlans(data);
          setPricingPlansLoading(false);
        } else {
          setPricingPlans([]);
          setPricingPlansLoading(false);
          console.error('Activity Search: Failed to fetch pricing plans');
        }

      } catch (error) {
        setPricingPlans([]);
        setPricingPlansLoading(false);
        console.error('Activity Search: Failed to fetch pricing plans');
      }
    }
  };

  const fetchActivityTypes = async () => {

    if (storedToken && activityTypes.length <= 1) {

      try {
        setActivityTypesLoading(true);
        const response = await fetch(activityTypesEndpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          data.unshift(defaulActivityType);
          setActivityTypes(data);
          setActivityTypesLoading(false);

        } else {
          setActivityType(defaulActivityType);
          setActivityTypesLoading(false);
          console.error('Activity Search: Failed to fetch activity types');
        }

      } catch (error) {
        setActivityType(defaulActivityType);
        setActivityTypesLoading(false);
        console.error('Activity Search: Failed to fetch activity types');
      }

    }

  }; 

  const getDatesFromRange = (range) => {

    let f = fromDate;
    let t = toDate;

    switch (range) {
      case 0: //upcoming
        f = formatDate(new Date('01/01/1980'));
        t = next(7);
        break;
      case 1: //Today
        f = today();
        t = f;
        break;
      case 2: //Next 7 Days
        f = today();
        t = next(7);
        break;
      case 3: //Next 30 Days
        f = today();
        t = next(30);
        break;
      case 4: //Last 7 Days
        f = last(7);
        t = today();
        break;
      case 5: //Last 30 Days
        f = last(30);
        t = today();
        break;
      case customDateRange: //Custom
      case allDateRange: //All
      default:
        break;
    }

    setFromDate(f);
    setToDate(t);
    setCustomDatesDisabled(range !== customDateRange);

  };

  useEffect(() => {
    getDatesFromRange(dateRange.value);
  }, [dateRange]);
      
  useEffect(() => {
    fetchSalesReps();
  }, [selectedParentID, selectedCompanyID]);

  useEffect(() => {
    fetchPricingPlans();
  }, []);
  
  //initialization of dropdowns
  useEffect(() => {
    if (storedToken) {
      fetchActivityTypes();
    }
  }, [allParents]);

 //open modal initializations
  useEffect(() => {
    if (showModal && storedToken) {

      //most of the lists below do not yet exist, can't set values until they do exist

      //move input filters into working state
      setParent(allParents.find(x => x.value === activityFilters.parentId));
      setCompany(allCompanies.find(x => x.value === activityFilters.companyId));

      if (activityFilters.contactId !== 0) {
        setContact({ label: activityFilters.contactName, value: activityFilters.contactId });
      } else {
        setContact(null);
      }

      const identity = jwtDecode(storedToken);

      if (activityFilters.activityFor === 0) {
        setActivityFor(null);
      } else if (activityFilters.activityFor === -1) { //current user
        setActivityFor(allEmployees.find(x => x.data === identity.sub.toUpperCase()));
      } else {
        setActivityFor(allEmployees.find(x => x.value === activityFilters.activityFor));
      }

      //setActivityFor(allEmployees.find(x => x.value === activityFilters.activityFor));

      setSalesRep(salesReps.find(x => x.value === activityFilters.salesRepId));
      setPricingPlan(pricingPlans.find(x => x.value === activityFilters.pricingPlanId));

      setActivityType(activityTypes.find(x => x.value === activityFilters.activityType));
      setRecurrence(recurrences.find(x => x.value === activityFilters.recurrence));
      setStatus(statuses.find(x => x.value === activityFilters.status));

      //setStatus(statuses[activityFilters.status]);

      setDateType(dateTypes[activityFilters.dateType]);
      setDateRange(dateRanges[activityFilters.dateRange]);

      //setApplyFilter(true);
    }

  }, [showModal]);

  //as filters change count them
  useEffect(() => {
    let count = 0;
    //parent/company does not count as a filter
    //if (parent.value !== 0) count += 1;
    //if (company.value !== 0) count += 1;

    const identity = jwtDecode(storedToken);

    //activityFilters.activityFor = -1; //-1 indicates the logged in user, 0 indicates any user (wildcard)
    //activityFilters.contactId = 0;
    //activityFilters.salesRepId = 0;
    //activityFilters.activityType = 0;
    //activityFilters.recurrence = - 1;
    //activityFilters.status = 0;
    //activityFilters.dateType = 0;
    //activityFilters.dateRange = 0;

    //if (activityFor && activityFor.data !== identity.sub.toUpperCase()) count += 1;
    if (!activityFor || activityFor.data !== identity.sub.toUpperCase()) count += 1;
    if (contact && contact.value !== 0) count += 1;
    if (salesRep && salesRep.value !== 0) count += 1;
    if (activityType && activityType.value !== 0) count += 1;
    if (recurrence && recurrence.value !== -1) count += 1;
    if (status && status.value !== 0) count += 1;
    if (dateType && dateType.value !== 0) count += 1;
    if (dateRange.value !== defaultDateRange) count += 1;
    //count += 1;

    setFilterTotal(count);
  }, [parent, company, contact, salesRep, activityFor, activityType, status, recurrence, dateType, dateRange]);

  useEffect(() => {
    setFilterMessage(`Search for activities amoung the last 5 years of history | ${filterTotal} filters applied`);
    
  }, [filterTotal]);


  //useEffect(() => {
  //  //reset company dropdown if the selected company is not part of parent
  //  if (!companyHasParent(company ? company.value : 0, parent ? parent.value : 0)) setCompany(null);
  //}, [parent]);

  //const companyHasParent = (companyId, parentId) => {
  //  if (companyId === 0) return true;
  //  if (parentId === 0) return true;
  //  //return (allCompanies.find(x => x.value === companyId)).ParentID === parentId;
  //  return (allCompanies.find(x => x.value === companyId)).TrendGroupId === parentId;
  //};

  //Date functions (ported from another project...)

  const formatDate = (dt) => {
    dt.setHours(0, 0, 0, 0);
    return dt;
  };

  //const daysInMonth = (dt) => { return new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate() };

  const today = () => { return formatDate(new Date()) };

  //const yesterday = () => {
  //  var dt = new Date();
  //  dt.setDate(dt.getDate() - 1);
  //  return formatDate(dt);
  //};

  //const tomorrow = () => {
  //  var dt = new Date();
  //  dt.setDate(dt.getDate() + 1);
  //  return formatDate(dt);
  //};

  const last = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() - days);
    return formatDate(dt);
  };

  const next = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() + days);
    return formatDate(dt);
  };

  //const thisWeek = (start) => {
  //  var dt = new Date();
  //  var day = dt.getDay();
  //  if (start) {
  //    dt.setDate(dt.getDate() - day);
  //  } else {
  //    dt.setDate(dt.getDate() + (6 - day));
  //  }
  //  return formatDate(dt);
  //};

  //const lastWeek = (start) => {
  //  var dt = new Date();
  //  var day = dt.getDay();
  //  if (start) {
  //    dt.setDate(dt.getDate() - 7 - day);
  //  } else {
  //    dt.setDate(dt.getDate() - 7 + (6 - day));
  //  }
  //  return formatDate(dt);
  //};

  //const nextWeek = (start) => {
  //  var dt = new Date();
  //  var day = dt.getDay();
  //  if (start) {
  //    dt.setDate(dt.getDate() + 7 - day);
  //  } else {
  //    dt.setDate(dt.getDate() + 7 + (6 - day));
  //  }
  //  return formatDate(dt);
  //};
  
  //const thisMonth = (start) => {
  //  var dt = new Date();
  //  var days = 1;
  //  if (!start) {
  //    days = daysInMonth(dt)
  //  }
  //  dt.setFullYear(dt.getFullYear(), dt.getMonth(), days)
  //  return formatDate(dt);
  //}

  //const lastMonth = (start) => {
  //  var dt = new Date();
  //  dt.setMonth(dt.getMonth() - 1);
  //  var days = 1;
  //  if (!start) {
  //    days = daysInMonth(dt)
  //  }
  //  dt.setFullYear(dt.getFullYear(), dt.getMonth(), days)
  //  return formatDate(dt);
  //};

  //const nextMonth = (start) => {
  //  var dt = new Date();
  //  dt.setMonth(dt.getMonth() + 1);
  //  var days = 1;
  //  if (!start) {
  //    days = daysInMonth(dt)
  //  }
  //  dt.setFullYear(dt.getFullYear(), dt.getMonth(), days)
  //  return formatDate(dt);
  //};
  
  //const thisQuarter = (start) => {
  //  var dt = new Date();
  //  var qStart = 9;
  //  var qEnd = 11;
  //  switch (dt.getMonth()) {
  //    case 0:
  //    case 1:
  //    case 2:
  //      qStart = 0;
  //      qEnd = 2;
  //      break;
  //    case 3:
  //    case 4:
  //    case 5:
  //      qStart = 3;
  //      qEnd = 5;
  //      break;
  //    case 6:
  //    case 7:
  //    case 8:
  //      qStart = 6;
  //      qEnd = 8;
  //      break;
  //    default:
  //  }
  //  if (start) {
  //    dt.setFullYear(dt.getFullYear(), qStart, 1);
  //  } else {
  //    dt.setFullYear(dt.getFullYear(), qEnd, 1);
  //    var days = daysInMonth(dt);
  //    dt.setFullYear(dt.getFullYear(), qEnd, days);
  //  }
  //  return formatDate(dt);
  //};

  //const lastQuarter = (start) => {
  //  var dt = new Date();
  //  var qStart = 9;
  //  var qEnd = 11;
  //  var qYear = dt.getFullYear();
  //  switch (dt.getMonth()) {
  //    case 3:
  //    case 4:
  //    case 5:
  //      qStart = 0;
  //      qEnd = 2;
  //      break;
  //    case 6:
  //    case 7:
  //    case 8:
  //      qStart = 3;
  //      qEnd = 5;
  //      break;
  //    case 9:
  //    case 10:
  //    case 11:
  //      qStart = 6;
  //      qEnd = 8;
  //      break;
  //    default:
  //      qYear -= 1;
  //  }

  //  if (start) {
  //    dt.setFullYear(qYear, qStart, 1);
  //  } else {
  //    dt.setFullYear(qYear, qEnd, 1);
  //    var days = daysInMonth(dt);
  //    dt.setFullYear(qYear, qEnd, days);
  //  }
  //  return formatDate(dt);
  //};

  //const nextQuarter = (start) => {
  //  var dt = new Date();
  //  var qStart = 0;
  //  var qEnd = 2;
  //  var addYear = 0;
  //  switch (dt.getMonth()) {
  //    case 0:
  //    case 1:
  //    case 2:
  //      qStart = 3;
  //      qEnd = 5;
  //      break;
  //    case 3:
  //    case 4:
  //    case 5:
  //      qStart = 6;
  //      qEnd = 8;
  //      break;
  //    case 6:
  //    case 7:
  //    case 8:
  //      qStart = 9;
  //      qEnd = 11;
  //      break;
  //    default:
  //      addYear = 1;
  //  }
  //  if (start) {
  //    dt.setFullYear(dt.getFullYear() + addYear, qStart, 1);
  //  } else {
  //    dt.setFullYear(dt.getFullYear() + addYear, qEnd, 1);
  //    var days = daysInMonth(dt);
  //    dt.setFullYear(dt.getFullYear() + addYear, qEnd, days);
  //  }
  //  return formatDate(dt);
  //};

  //const thisYear = (start) => {
  //  var dt = new Date();
  //  if (start) {
  //    dt.setFullYear(dt.getFullYear(), 0, 1)
  //  } else {
  //    dt.setFullYear(dt.getFullYear(), 11, 31)
  //  }
  //  return formatDate(dt);
  //};

  //const lastYear = (start) => {
  //  var dt = new Date();
  //  if (start) {
  //    dt.setFullYear(dt.getFullYear() - 1, 0, 1)
  //  } else {
  //    dt.setFullYear(dt.getFullYear() - 1, 11, 31)
  //  }
  //  return formatDate(dt);
  //};

  //const nextYear = (start) => {
  //  var dt = new Date();
  //  if (start) {
  //    dt.setFullYear(dt.getFullYear() + 1, 0, 1)
  //  } else {
  //    dt.setFullYear(dt.getFullYear() + 1, 11, 31)
  //  }
  //  return formatDate(dt);
  //};


  const loadParentOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(parentsSearch + `?searchterm=${searchterm}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadCompanyOptions = async (searchterm) => {

    let results = [];
    let parentid = parent ? parent.value : 0;

    const response = await fetch(companySearch + `?searchterm=${searchterm}&parentid=${parentid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadIndividualOptions = async (searchterm) => {

    let results = [];
    let parentid = parent ? parent.value : 0;
    let companyid = company ? company.value : 0;

    const response = await fetch(individualsSearch + `?searchterm=${searchterm}&parentid=${parentid}&companyid=${companyid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };


  return(
    <Modal show={showModal} onHide={closeModal} dialogClassName="activity-filter-modal" backdrop="static">
        <Modal.Header closeButton>
        <Modal.Title>
          Search Filters
          <span className="activity-search-title-desc">{filterMessage}</span>
        </Modal.Title>
        </Modal.Header>
      <Modal.Body>

        {/*row 1*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6" controlId="parent">
            <FloatingLabel className="floating-select" label={`Company Parent`}>

              <AsyncSelect
                name="parent"
                className="filter-activity"
                classNamePrefix="select"
                isClearable={true}
                cacheOptions
                loadOptions={loadParentOptions}
                defaultOptions={true}
                value={parent}
                onChange={handleParentChange}
                menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom
                menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />

              {/*<Select*/}
              {/*  className="filter-activity"*/}
              {/*  classNamePrefix="select"*/}
              {/*  options={parents}*/}
              {/*  value={parent}*/}
              {/*  onChange={handleParentChange}*/}
              {/*  filterOption={createFilter({ ignoreAccents: false })} //this for performance*/}
              {/*  components={{ Option: CustomOption }} //this for performance*/}
              {/*/>*/}

            </FloatingLabel>
          </Form.Group>

          <Form.Group className='mb-3' as={Col} md="6" controlId="type">
            <FloatingLabel className="floating-select" label={`Activity Type`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={activityTypes}
                value={activityType}
                isLoading={activityTypesLoading}
                onChange={handleActivityTypeChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 2*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6" controlId="company">
            <FloatingLabel className="floating-select" label={`Company`}>

              <AsyncSelect
                name="company"
                className="filter-activity"
                classNamePrefix="select"
                isClearable={true}
                key={parent ? parent.value : 0} //this is the magic bit that forces the reload
                cacheOptions
                loadOptions={loadCompanyOptions}
                defaultOptions={true}
                value={company}
                onChange={handleCompanyChange}
                menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom
                menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />

            {/*  <Select*/}
            {/*    className="filter-activity"*/}
            {/*    classNamePrefix="select"*/}
            {/*    options={companies}*/}
            {/*    value={company}*/}
            {/*    onChange={handleCompanyChange}*/}
            {/*    //filterOption={createFilter({ ignoreAccents: false })}  //this for performance*/}
            {/*    components={{ Option: CustomOption }}  //this for performance*/}
            {/*    filterOption={(option) => parent.value === 0 || companyHasParent(option.value, parent.value)}*/}
              {/*  />*/}

            </FloatingLabel>
          </Form.Group>

          <Form.Group className='mb-3' as={Col} md="6" controlId="recurrence">
            <FloatingLabel className="floating-select" label={`Recurrence`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={recurrences}
                value={recurrence}
                onChange={handleRecurrenceChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 3*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6" controlId="contact">
            <FloatingLabel className="floating-select" label={`Contact`}>

              <AsyncSelect
                name="individual"
                className="filter-activity"
                classNamePrefix="select"
                isClearable={true}
                key={parent ? parent.value : (company ? company.value : 0)} //this is the magic bit that forces the reload
                cacheOptions
                loadOptions={loadIndividualOptions}
                defaultOptions
                value={contact}
                onChange={handleContactChange}
                menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />

            {/*  <Select*/}
            {/*    className="filter-activity"*/}
            {/*    classNamePrefix="select"*/}
            {/*    options={contacts}*/}
            {/*    value={contact}*/}
            {/*    isLoading={contactsLoading}*/}
            {/*    onChange={handleContactChange}*/}
            {/*    filterOption={createFilter({ ignoreAccents: false })}  //this for performance*/}
            {/*    components={{ Option: CustomOption }}  //this for performance*/}
            {/*  />*/}

            </FloatingLabel>
          </Form.Group>

          <Form.Group className='mb-3' as={Col} md="6" controlId="pricingplan" style={{ display: 'none' }}>
            <FloatingLabel className="floating-select" label={`Pricing Plan`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={pricingPlans}
                value={pricingPlan}
                isLoading={pricingPlansLoading}
                isClearable={true}
                onChange={handlePricingPlanChange}
                filterOption={createFilter({ ignoreAccents: false })} //this for performance
                components={{ Option: CustomOption }} //this for performance
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group className='mb-3' as={Col} md="6" controlId="dateType">
            <FloatingLabel className="floating-select" label={`Date`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={dateTypes}
                value={dateType}
                onChange={handleDateTypeChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 4*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6" controlId="salesRep">
            <FloatingLabel className="floating-select" label={`Sales Rep.`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={salesReps}
                value={salesRep}
                isLoading={salesRepsLoading}
                isClearable={true}
                onChange={handleSalesRepChange}
                filterOption={createFilter({ ignoreAccents: false })} //this for performance
                components={{ Option: CustomOption }} //this for performance
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group className='mb-3' as={Col} md="6" controlId="dateRange">
            <FloatingLabel className="floating-select" label={`Date Range`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={dateRanges}
                value={dateRange}
                onChange={handleDateRangeChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 5*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6" controlId="status">
            <FloatingLabel className="floating-select" label={`Assigned To`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={allEmployees}
                value={activityFor}
                isClearable={true}
                onChange={handleActivityForChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 6*/}
        <Row className='mb-0'>

          <Form.Group as={Col} md="6" controlId="status">
            <FloatingLabel className="floating-select" label={`Status`}>
              <Select
                className="filter-activity"
                classNamePrefix="select"
                options={statuses}
                value={status}
                onChange={handleStatusChange}
              />
            </FloatingLabel>
          </Form.Group>

          {dateRange.value === customDateRange ? (
            <>
              <Form.Group as={Col} md="3" controlId="fromDate">
                <FloatingLabel className="floating-datepicker" label={`From`}>
                  <DatePicker
                    className="activity-search-datepicker"
                    dateFormat="E. MM/dd/yyyy"
                    disabled={customDatesDisabled}
                    selected={fromDate}
                    onChange={(date) => handleFromDateChange(date)}
                    showIcon
                    icon="fa fa-calendar"
                    toggleCalendarOnIconClick
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="3" controlId="fromDate">
                <FloatingLabel className="floating-datepicker" label={`To`}>
                  <DatePicker
                    className="activity-search-datepicker"
                    dateFormat="E. MM/dd/yyyy"
                    disabled={customDatesDisabled}
                    selected={toDate}
                    onChange={(date) => handleToDateChange(date)}
                    minDate={fromDate}
                    showIcon
                    icon="fa fa-calendar"
                    toggleCalendarOnIconClick
                  />
                </FloatingLabel>
              </Form.Group>
            </>
          ) : null}
        </Row>

      </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={resetFilters}>
            Reset
          </Button>
        <Button variant="primary" onClick={viewFilters}>
            View
          </Button>
        </Modal.Footer>
      </Modal>
  );
}